import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import messages from '../../translation_hotkey_template';


class NewPanelItem extends Component {
  render() {
    let { meta, label, height, width, header, onClick, intl } = this.props;

    if (label === 'Add') {
      label = intl.formatMessage( messages.label_add )
    }

    return (
      <div className="ui link add card" style={{ height, width }} onClick={onClick}>
        <div className="content" style={{ padding: 5 }}>
          {meta}
          <div className={`center aligned description ${header && 'header'} ht-group-name`}>
            {label}
          </div>
        </div>
      </div>
    );
  }
}


export default injectIntl(NewPanelItem);
